import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlReferenceService } from "./url-reference.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  constructor(private http: HttpClient, private urlRef: UrlReferenceService) {}

  //update profile information
  updateProfile(profileData: any): Observable<any> {
    return this.http.post(`${this.urlRef.getUpdateProfileUrl()}`, profileData);
  }

  // Change password
  changePassword(passwordData: any): Observable<any> {
    return this.http.post(`${this.urlRef.getChangePasswordUrl()}`, passwordData);
  }

  // Verify current password
  verifyCurrentPassword(passwordData: any): Observable<any> {
    return this.http.post(
      `${this.urlRef.getVerifyCurrentPasswordUrl()}`,
      passwordData
    );
  }
}
